import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

type UserLocation = {
  id: number;
  title: string;
  status?: string;
}
export interface ImpersonationDialogData {
  userId: number;
  userName: string;
  userEmail: string;
  locations?: UserLocation[];
  userRole?: string;
  ttlMinutes?: number;
}

@Component({
  selector: 'app-impersonation-confirm-dialog',
  templateUrl: './impersonation-confirm-dialog.component.html',
  styleUrls: ['./impersonation-confirm-dialog.component.scss'],
})
export class ImpersonationConfirmDialogComponent {
  ttlMinutes: number;
  reason: string = '';
  selectedLocation: number | null = null;
  public dialogRef = inject(MatDialogRef<ImpersonationConfirmDialogComponent>);
  public data = inject<ImpersonationDialogData>(MAT_DIALOG_DATA);

  // Define options as properties instead of methods to avoid infinite loop
  readonly ttlOptions = [
    { value: 15, label: '15 minutes' },
    { value: 30, label: '30 minutes' },
    { value: 60, label: '1 hour' },
    { value: 120, label: '2 hours' },
    { value: 240, label: '4 hours' },
    { value: 480, label: '8 hours' },
  ];

  readonly reasonOptions = [
    { value: 'technical_support', label: 'Technical Support' },
    { value: 'incident_resolution', label: 'Incident Resolution' },
    { value: 'user_assistance', label: 'User Assistance' },
    { value: 'system_testing', label: 'System Testing' },
    { value: 'data_verification', label: 'Data Verification' },
    { value: 'training_demo', label: 'Training/Demo' },
    { value: 'configuration_support', label: 'System Configuration' },
    { value: 'other', label: 'Other' },
  ];

  constructor() {
    this.ttlMinutes = this.data.ttlMinutes || 60;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    const result = {
      ttlMinutes: this.ttlMinutes,
      reason: this.reason || `Impersonate ${this.data.userName}`,
      location: this.selectedLocation,
    };
    this.dialogRef.close(result);
  }
}
